export const THEMES_LIST_URL: string = 'passportThemes/list';
export const THEMES_LIST_SEARCH_URL: string = 'passportThemes/search';
export const NEW_THEME_URL: string = 'passportThemes';
export const UPDATE_THEME_URL: string = 'passportThemes/{id}';
export const GET_THEME_S3_URL: string = 'passportThemes/upload-url';
